export function copyToClipboard(value) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(value);
  } else {
    console.error('Browser does not support clipboard');
  }
}
